function initNav() {
  const nav = document.querySelector('.nav');
  const burger = document.querySelector('.nav__burger');
  const drawer = document.querySelector('.nav__drawer');
  const closeBtn = document.querySelector('.nav__drawer-close');

  if (!burger || !drawer) return;

  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (drawer.classList.contains('is-open')) {
      lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY <= 10) {
      nav.classList.remove('is-hidden');
    } else if (currentScrollY > lastScrollY) {
      nav.classList.add('is-hidden');
    } else {
      nav.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  }, { passive: true });

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  document.querySelectorAll('a[href^="#"]').forEach(link => {
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    link.addEventListener('click', (e) => {
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      closeDrawer();
      window._isNavScrolling = true;
      gsap.to(window, {
        scrollTo: { y: target },
        duration: 1,
        ease: 'power2.inOut',
        onComplete: () => { window._isNavScrolling = false; },
      });
    });
  });
}
